<template>
  <div>
    <h2 class="title">
      Acerca de la propiedad
    </h2>
    <p v-html="contentDetail">
    </p>
    <h2 class="title">Actualizaciones:</h2>
    <div class="panel-group updates" id="accordion" role="tablist" aria-multiselectable="false">
      <div v-for="(item, index) in updates" :key="index" class="panel">
        <div class="panel-heading" role="tab" id="headingOne">
          <h4 class="panel-title">
            <a class="panel-handler" role="button" data-toggle="collapse" data-parent="#accordion" :href="'#collapse' + index" aria-expanded="true" aria-controls="collapseOne">
              <span>
                Actualización {{ item.date }}
              </span>
              <svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.49707 18.3233L11.5717 20.3979L17.0691 14.9006L22.5664 20.3979L24.6411 18.3233L17.0691 10.746L9.49707 18.3233Z" fill="#3A2E85"/>
              </svg>
            </a>
          </h4>
        </div>
        <div :id="'collapse' + index" class="panel-collapse collapse in show" role="tabpanel" aria-labelledby="headingOne">
          <div class="panel-body" v-html="item.content">
            
          </div>
        </div>
      </div>
    </div>
    <h2 class="title">{{ property.attributes.titleLocation }}</h2>
    <iframe class="location__iframe" :src="property.attributes.urlEmbedGoogleMaps" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
  </div>
</template>
<script>
export default {
  name: 'DetailsTab',
  props: {
    property: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      updates:[],
      contentDetail:''
    }
  },
  methods: {
    getContent(content) {
      var MarkdownIt = require('markdown-it'),
      md = new MarkdownIt();
      var result = md.render(content);
      return result
    }
  },
  mounted () {
    let array = this.property.attributes.property_updates.data
    this.contentDetail =  this.getContent(this.property.attributes.Details.toString())
    let contentHTML
    for (const item of array) {
      contentHTML = this.getContent(item.attributes.Description)
      this.updates.push({date:item.attributes.UpdateDate , content: contentHTML})
    }
    console.log('ESto paso en la property DETALLE', this.updates)
  },
  
}
</script>

<style lang="scss">
.title {
  font-size: 24px;
  line-height: 30px;
  font-weight: 600;
  font-family: 'Montserrat', sans-serif;
  color: #351467;
  margin-bottom: 24px;
}

p {
  font-family: 'Roboto', sans-serif;
  line-height: 22px;
  color: #000000;
}

p + p {
  margin-top: 16px;
}

.panel-title {
  border-bottom: 2px solid #351467;
  padding: 0 14px;
  padding-top: 12px;
  margin: 0;
}

.panel-handler {
  color: #000 !important;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
  border-radius: 4px;
  width: 100%;
}

.panel-handler svg {
  transform: rotate(180deg);
  transition: transform 0.3s ease-in-out;
}

.panel-handler[aria-expanded="true"] span {
  color: #351467 !important;
  background-color: #DEFBEC;
}

.panel-handler[aria-expanded="true"] svg {
  transform: rotate(0deg);
}

.panel-handler span {
  padding: 4px 8px;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  max-width: max-content;
}

.panel-body {
  padding: 32px 16px;
  background-color: #FAFAFA;
}

.updates {
  margin-bottom: 36px;
}

.location__iframe {
  width: 100%;
}
</style>